import { useTranslation } from "react-i18next";

import Modal from "components/Map/components/Modal/Modal";

import styles from "./LanguageChangeErrorModal.module.scss";

interface Props {
  onClick: () => void;
}

export default function LanguageChangeErrorModal({ onClick }: Props) {
  const { t } = useTranslation();

  return (
    <Modal
      dataQA="language-change-error-modal"
      title={t("language_change_error_modal.title")}
      onBgClick={onClick}
      onButtonClick={onClick}
      buttonLabel={t("language_change_error_modal.close_button_text")}
    >
      <div className={styles.modalBody}>
        {t("language_change_error_modal.message")}
      </div>
    </Modal>
  );
}
